export const mtikTheme = {
  colors: {
    primary: "#3e76bd",
    primaryHover: "#255a9c",
    text: "#383838",
    textSecondary: "#7a7a7a",
    textTertiary: "#969393",
    border: "#c2c2c2",
    borderSecondary: "#ededed",
    borderInput: "#c2c2c2",
    background: "#ffffff",
    backgroundSecondary: "#f6f6f6",
    link: "#3e76bd",
    tabActive: "#3e76bd",
    focusBorder: "#3e76bd",
    focusRing: "rgba(62, 118, 189, 0.25)",
    error: "#a7261c",
    errorBackground: "#f8ebea",
    success: "#25955e",
    successBackground: "#ebf8f2",
  },
  radii: {
    input: "4px",
    button: "4px",
  },
};
